export default "__VITE_ASSET__tsGKJ8nc__"